/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { NavigationViewIdKey, Props, State } from './NavigationView.types.tsx';
import { deleteViewFromState } from './deleteViewFromState.tsx';
import { withRefreshBlocker } from './withRefreshBlocker.tsx';
import { findViewBy, modifyView } from './updateContainerState.tsx';

export const syncViewName = (viewId: string, type: ViewKind, name: string): Action<State, Props> =>
	withRefreshBlocker(async ({ setState, getState }, props) => {
		const { cloudId, containerId, containerType } = props;

		if (
			!cloudId ||
			!containerId ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		const viewIdKey: NavigationViewIdKey = containerType === 'COLLECTION' ? 'id' : 'polarisId';

		const { view } = findViewBy(
			getState().containers[containerId],
			(innerView) => String(innerView[viewIdKey]) === viewId && innerView.viewType === type,
		);

		if (!view) {
			return;
		}

		if (view.name === name) {
			return;
		}

		setState(
			modifyView(getState(), containerId, (innerView) => {
				if (String(innerView[viewIdKey]) === viewId && innerView.viewType === type) {
					return {
						...innerView,
						name,
					};
				}
				return innerView;
			}),
		);
	});

export const syncViewEmoji = (
	viewId: string,
	type: ViewKind,
	emoji: string | undefined,
): Action<State, Props> =>
	withRefreshBlocker(async ({ setState, getState }, props) => {
		const { cloudId, containerId, containerType } = props;
		if (
			!cloudId ||
			!containerId ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		const viewIdKey: NavigationViewIdKey = containerType === 'COLLECTION' ? 'id' : 'polarisId';

		const { view } = findViewBy(
			getState().containers[containerId],
			(innerView) => String(innerView[viewIdKey]) === viewId && innerView.viewType === type,
		);
		if (!view) {
			return;
		}

		if (view.emoji === emoji) {
			return;
		}

		setState(
			modifyView(getState(), containerId, (innerView) => {
				if (String(innerView[viewIdKey]) === viewId && innerView.viewType === type) {
					return {
						...innerView,
						emoji,
					};
				}
				return innerView;
			}),
		);
	});

export const syncViewDeletion = (viewId: string, type: ViewKind): Action<State, Props> =>
	withRefreshBlocker(async ({ dispatch, getState }, props) => {
		const { cloudId, containerId, containerType } = props;
		if (
			!cloudId ||
			!containerId ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		const viewIdKey: NavigationViewIdKey = containerType === 'COLLECTION' ? 'id' : 'polarisId';

		const { view } = findViewBy(
			getState().containers[containerId],
			(innerView) => String(innerView[viewIdKey]) === viewId && innerView.viewType === type,
		);

		if (!view) {
			return;
		}

		dispatch(deleteViewFromState(view.id));
	});
